import React from 'react';
import { formatKwh, formatDecimal, formatPercentage } from '../../../../../lib/formatters';
import { arrowUp, arrowDown } from '../../../../../lib/icons';

export default function HistoricalTotals({historicalData, historicalUnit="kwh", omitDelta, type, inverted}){
  const { deltas, totals } = historicalData;
  const [currTotals] = totals;
  function getValue(totals){
    const total = totals.find((item) => item.type === type);
    if(!total){
      return null;
    }
    return total[historicalUnit];
  }

  let formatter = formatDecimal;
  if(historicalUnit === 'percent'){
    formatter = formatPercentage;
  }

  function mainLabel(value){
    let [num, unit] = formatKwh(value);
    if(historicalUnit === 'percent'){
      num = value;
      unit = '';
    }

    // assume anything that's inverted should be flipped before display
    if(inverted){
      num = -num;
    }

    value = isNaN(value)
      ? 0
      : value;

    return <span className="current">
      <span className="value">{formatter(num)}</span>&nbsp;<span className="unit">{unit}</span>
    </span>
  }

  function deltaLabel(value){
    if(historicalUnit === 'kwh'){
      const [v] = formatKwh(value);
      value = v;
    }
    if(inverted){
      value = -value;
    }

    const positiveChange = value >= 0; 

    const statusClasses = ['bad', 'good']
    if(inverted){
      statusClasses.reverse();
    }

    const classes = [
      'delta',
      positiveChange
        ? statusClasses[0]
        : statusClasses[1]
    ];

    return <span className={classes.join(' ')}>
      { positiveChange ? arrowUp : arrowDown }{formatter(Math.abs(value))}
    </span>
  }  

  return <div className="historical-totals">
    { 
    currTotals?.length > 0 && mainLabel(getValue(currTotals))
    }
    &nbsp;
    {
    (!omitDelta && deltas?.length > 0) && deltaLabel(getValue(deltas))
    }
  </div>;
}